import { useLocation } from 'react-router';
import { css } from '@emotion/react';
import { SideBar, SidebarLink, SideMenuHeader } from './side-bar-utils';
import { useMetaSelector } from '../../meta/reducer';
import { FeatureFlagNames } from '@birdi/js-sdk/src/public/organisation-features';
import BottomSection from './bottom-section';

const SideNavigationInspectionTools = () => {
  const location = useLocation();
  const meta = useMetaSelector();
  const inspection =
    meta.orgFeatureFlags.includes(
      FeatureFlagNames.PowercorInspectionDashboard,
    ) && meta.permissions.includes('workspace:mission:manage');
  return (
    <div
      css={css`
        position: relative;
      `}
    >
      <SideBar>
        <SideMenuHeader label="Inspection Tools" id="inspection-tools" />
        <SidebarLink to="/assessment-types" match={location.pathname}>
          <span>Assessment Types</span>
        </SidebarLink>
        <SidebarLink to="/assessment-severity" match={location.pathname}>
          <span>Assessment Severity</span>
        </SidebarLink>
        <SidebarLink
          to={inspection ? '/inspection-summary' : '#'}
          match={location.pathname}
          disabled={!inspection}
        >
          <span id="inspection-summary">Inspection Summary</span>
        </SidebarLink>
        <div
          css={css`
            height: 7em;
          `}
        />
      </SideBar>
      <BottomSection />
    </div>
  );
};

export default SideNavigationInspectionTools;
